





































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import AButton from "./private/AButton.vue";
import AbcTimePicker from "./AbcTimePicker.vue";
import HeaderButton from "./private/HeaderButton.vue";
import DayPicker from "./private/DayPicker.vue";
import MonthPicker from "./private/MonthPicker.vue";
import YearPicker from "./private/YearPicker.vue";
import PickerMixin from "./private/PickerMixin";

@Component({
    components: {
        AButton,
        HeaderButton,
        DayPicker,
        MonthPicker,
        YearPicker,
        AbcTimePicker,
    },
})
export default class AbcDateTimePicker extends Mixins(PickerMixin) {

    @Prop({ type: Boolean }) hideDelete!: boolean;
    @Prop({ type: Boolean }) hideToday!: boolean;
    @Prop({ type: Boolean }) customWidth!: boolean;

    withTime = true;

    private clear() {
        this.selectedDate = null;
        this.ref = new Date();
    }
}
